import {
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
    Input,
    Select,
    Box,
    Flex,Image,
    Text,Button,Card,CardBody,SimpleGrid,
    Textarea,Checkbox
  } from "@chakra-ui/react";
  import { toast } from "react-hot-toast";
  import { useSelector } from "react-redux";
  
  import axios from 'axios'
  import "react-calendar/dist/Calendar.css";
  import Calendar from "react-calendar";
  //import toast from "react-hot-toast";
  import React, { useState,useEffect } from "react";
import { split } from "lodash";

  
 
  
  const PrintData = () => {
    // const [data1, setData1] = useState(new Date());
    // console.log(data1.toDateString());
    // const [data2, setData2] = useState(new Date());
    // console.log(data2.toDateString());
    // const [total, setTotal] = useState(0);
    // const [advance, setAdvance] = useState(0);
    //let dueAmount = 0;
    const [dueAmount, setDueAmount] = useState(0); 
    const [data,setData]=useState([]);
    const [disable,setDisable]=useState(false);
    const [id,setId]=useState('')
    const [selectedFile, setSelectedFile] = useState(null);
  const[imageURL,setImageURL]=useState(null);
  const [uploading, setUploading] = useState(false);
  const [images,setImages]=useState([])
 const customerId=localStorage.getItem('customerId');
 const fetchData=async()=>{
  try {
    const response=await axios.get(`https://api.rcb.tdrsoftware.in/api/getPrintData/${customerId}`);
    setData(response.data);
  } catch (error) {
    toast.error(error.message);
  }
 }
 const handleCheckboxChange = (e) => {
  const { name, checked } = e.target;
  setFormData((prevFormData) => ({
    ...prevFormData,
    [name]: checked, // Set formData.halfPlate to true/false based on checkbox state
  }));
};
 const handlePost = async () => {
  try {
    setUploading(true);

    if (!selectedFile) {
      toast.error("Please select a file to upload.");
      return;
    }

    const formData = new FormData();
    formData.append('image', selectedFile); // Ensure 'image' matches the backend field name

    const response = await axios.post(
      "https://api.rcb.tdrsoftware.in/upload", // Corrected URL
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    const data = response.data;

    // Update state with uploaded image URL
    setImageURL(data.filename); // Adjust based on backend response
    toast.success("Image uploaded successfully");
    console.log(data, 'Upload response');
  } catch (err) {
    console.error("Upload failed:", err);
    toast.error("Image upload failed. Please try again.");
  } finally {
    setUploading(false);
  }
};

    console.log(imageURL,'imageURL')
    
    const [formData, setFormData] = useState({
      name: "",
      adress: "",
      phoneNo:"",
      email:'',
      acNo:'',
       ifsc:'',
       branch:'',
       website:"",
       gstNo:"",
       happyHour:false,
       happyHourDiscount:null,
       happyHourFrom:"",
       happyHourTo:"",
       
     
      
      image: "",
      gst:false,
      splitBill:false,
      priceAdd:false,
      priceAddPercentage:null,
      hsnView:false,
      
      
      
    });
    const handleFileChange = (event) => {
      setSelectedFile(event.target.files[0]);
     
      
    }
      

    const validateForm = () => {
      const requiredFields = [
        "name",
        "adress",
        "phoneNo",
        "email",
        
        
        
      ];
  
      for (const field of requiredFields) {
        if (!formData[field]) {
          return false;
        }
      }
      return true;
    };
  
    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData({
        ...formData,
        [name]: value,
      });
    };
  useEffect(()=>{
    fetchData();
  },[customerId])
  console.log(data.map(i=>{return i}),'data')
   const convertAMPMTo24Hour = (timeStr) => {
  const [time, modifier] = timeStr.split(' ');
  let [hours, minutes] = time.split(':').map(Number);

  if (modifier === 'PM' && hours < 12) {
    hours += 12;
  }
  if (modifier === 'AM' && hours === 12) {
    hours = 0;
  }

  return `${hours?.toString().padStart(2, '0')}:${minutes?.toString().padStart(2, '0')}`;
};
  useEffect(()=>{
    if(data){
      const print=data.map(i=>{return i
         }
      )
      setId(data[0]?._id)
      setFormData({
        name: data[0]?.name|| "",
        adress:data[0]?.adress || "",
        phoneNo:data[0]?.phoneNo ||"",
        email:data[0]?.email||'',
        acNo:data[0]?.acNo||'',
         ifsc:data[0]?.ifsc||'',
         branch:data[0]?.branch||'',
         website:data[0]?.website ||"",
         gstNo:data[0]?.gstNo||"",
         gst:data[0]?.gst || false,
         happyHour:data[0]?.happyHour||false,
         happyHourDiscount:data[0]?.happyHourDiscount||null,
         happyHourFrom:data[0]?.happyHourFrom ? convertAMPMTo24Hour(data[0]?.happyHourFrom) :"",
         happyHourTo:data[0]?.happyHourTo ? convertAMPMTo24Hour(data[0]?.happyHourTo) :"",
         priceAdd:data[0]?.priceAdd||false,
         priceAddPercentage:data[0]?.priceAddPercentage||null,
         
       
        
        image: data[0]?.image||"",
        splitBill:data[0]?.splitBill||false,
        hsnView:data[0]?.hsnView||false,
      })
    }
  },[data])
   const formatTimeToAMPM = (time) => {
    const formattedTime = new Date(`6000-01-01T${time}`);
    return formattedTime.toLocaleString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    });
  };
 

  console.log(formatTimeToAMPM(formData.happyHourFrom),'formData')
 

    const handleSubmit = async(e) => {
      if (!validateForm()) {
        toast.error("Please fill in all required fields.");
        return;
      }
      e.preventDefault();
      // Here you can send formData to your backend server or process it further
      console.log("Form submitted with data:", formData);
     
      // Reset form after submission
      setFormData({
        name: formData.name,
      adress:formData.adress,
      phoneNo:formData.phoneNo,
      email:formData.email,
      acNo:formData.acNo,
      ifsc:formData.ifsc,
      branch:formData.branch,
      website:formData.website,
      gstNo:formData.gstNo,
      gst:formData.gst,
      splitBill:formData.splitBill,
      
      image:imageURL,
      happyHour:formData.happyHour,
      happyHourDiscount:formData.happyHourDiscount,
      happyHourFrom:formatTimeToAMPM(formData.happyHourFrom),
      happyHourTo:formatTimeToAMPM(formData.happyHourTo),
      hsnView:formData.hsnView,
      
       
      });
    
      
    };
    console.log(formData,'formData')
    const save = async (e) => {
      if (!validateForm()) {
        toast.error("Please fill in all required fields.");
        return;
      }
      
    
      // Update formData with the latest imageURL before sending to the server
      const updatedFormData = {
        ...formData,
        image: imageURL, // Directly use the updated imageURL here
      };
      if(data.length>0){
        const updateData={

          name: formData.name,
      adress:formData.adress,
      phoneNo:formData.phoneNo,
      email:formData.email,
      acNo:formData.acNo,
      ifsc:formData.ifsc,
      branch:formData.branch,
      website:formData.website,
      gstNo:formData.gstNo,
      gst:formData.gst,
      splitBill:formData.splitBill,
      happyHour:formData.happyHour,
      happyHourDiscount:formData.happyHourDiscount,
      happyHourFrom:formatTimeToAMPM(formData.happyHourFrom),
      happyHourTo:formatTimeToAMPM(formData.happyHourTo),
      priceAdd:formData.priceAdd,
      priceAddPercentage:formData.priceAddPercentage,
      hsnView:formData.hsnView,
      
      image:formData.image === "" || null ?imageURL:formData.image}
        try {
          const response=await axios.put(`https://api.rcb.tdrsoftware.in/api/updatePrintData/${customerId}/${id}`,{updatedData:updateData});
          toast.success(response.data.message)
          setId("")
          window.location.reload()
        } catch (error) {
          if(error.response && error.response === 404){
            toast.error(error.response.message)

          }
        }
        
      }else{
    
      try {
        const response = await axios.post("https://api.rcb.tdrsoftware.in/api/printRegister", {
          customerId: customerId,
          data: updatedFormData,
        });
    
        console.log("Data Submitted: ", response.data);
        toast.success(response.data.message);
    
        // Reset form after submission
        setFormData({
          name: "",
          adress: "",
          phoneNo: "",
          email: "",
          acNo: "",
          ifsc: "",
          branch: "",
          website: "",
          gstNo: "",
          image: "",
          happyHour: false,
          happyHourDiscount: null,
          happyHourFrom: "",
          happyHourTo: "",
          hsnView: false,
          
        });
      } catch (error) {
        toast.error(error.message);
      }
    }
    };
    
    
    return (
      <Box   bg='#f7f7f7 '
      columns={{ sm: 2, md: 4 }}
      spacing='8'
      p='10'
      textAlign='center'
      
      color='black' width='full' height='fit-content' overflowX='auto'  >
        
        <FormControl isRequired onSubmit={handleSubmit}>
          <Box display="grid"  gridGap={1} >
            <Flex
              display="flex"
              gap="10px"
              alignItems="center"
              justifyContent="space-evenly"
             
            >
              <Box width="40%"  display="flex" alignItems="center" boxShadow='xl'
              borderRadius="5px"
              
              p={4}>
                <FormLabel  >Bar & Restaturant Name</FormLabel>
                <Input w='70%' bg='#FAFAFA ' placeholder="Enter  Name "  border='1px solid #ffe4d9' name='name' value={formData.name} onChange={handleInputChange} />
              </Box>
              <Box width="40%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel>Address</FormLabel>
                <Textarea w='70%' bg='#FAFAFA ' border='1px solid #ffe4d9' type="text" placeholder="Enter Address" name='adress' value={formData.adress} onChange={handleInputChange} />
              </Box>
            </Flex>
            <Box
              display="flex"
              gap="10px"
              alignItems="center"
              justifyContent="space-evenly"
              
            >
              <Box width="30%" display="flex" alignItems="center" boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel>Phone</FormLabel>
                <Input w='66%' bg='#FAFAFA '  border='1px solid #ffe4d9' placeholder="Enter Phone" name='phoneNo' value={formData.phoneNo} onChange={handleInputChange}/>
                 
                 
                
              </Box>
              <Box width="30%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel>Email</FormLabel>
                <Input w='70%'  bg='#FAFAFA ' border='1px solid #ffe4d9' placeholder="Enter Email" name='email' value={formData.email} onChange={handleInputChange} />
                  
                  
              </Box>
               <Box width="30%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                {/* <FormLabel>Email</FormLabel> */}
                <Checkbox w='70%'  bg='#FAFAFA ' border='1px solid #ffe4d9' placeholder="Enter Email" name='hsnView' isChecked={formData.hsnView} onChange={handleCheckboxChange} >HsnView</Checkbox>
                  
                  
              </Box>
              
             
            </Box>
            <Box
              display="flex"
              gap="10px"
              alignItems="center"
              justifyContent="space-evenly"
              
            >
                <Box width="40%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel>Website</FormLabel>
                <Input w='70%'  bg='#FAFAFA ' border='1px solid #ffe4d9' placeholder="Bar&Restaurant Website" name='website' value={formData.website} onChange={handleInputChange} />
                  
                  
              </Box>
              <Box width="30%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel>GST No</FormLabel>
                <Input w='80%'  bg='#FAFAFA ' border='1px solid #ffe4d9' placeholder="GST No" name='gstNo' value={formData.gstNo} onChange={handleInputChange}/>
              </Box>
              <Box width="30%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel>GST </FormLabel>
                <Checkbox w='80%'  bg='#FAFAFA ' border='1px solid #ffe4d9' placeholder="GST " name='gst' isChecked={formData.gst} onChange={handleCheckboxChange}>Gst</Checkbox>
              </Box>
              <Box width="30%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel>SplitBill </FormLabel>
                <Checkbox w='60%'  bg='#FAFAFA ' border='1px solid #ffe4d9' placeholder="GST " name='splitBill' isChecked={formData.splitBill} onChange={handleCheckboxChange}>SplitBill</Checkbox>
              </Box>
              
            </Box>
             <Box
              display="flex"
              gap="10px"
              alignItems="center"
              justifyContent="space-evenly"
              
            >
              <Box width="20%" display="flex" alignItems="center" boxShadow='xl'
              borderRadius="5px"
              p={4}>
                
                <Checkbox w='66%' bg='#FAFAFA '  border='1px solid #ffe4d9' placeholder="Enter Phone" name='happyHour' isChecked={formData.happyHour}  onChange={handleCheckboxChange}>HappyHour</Checkbox>
                 
                 
                
              </Box>
              <Box width="20%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel>HappyHour Discount</FormLabel>
                <Input w='70%'  bg='#FAFAFA ' border='1px solid #ffe4d9' placeholder="Enter Discount" name='happyHourDiscount' value={formData.happyHourDiscount} onChange={handleInputChange} />
                  
                  
              </Box>
              <Box width="20%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel>From</FormLabel>
                <Input w='80%'  bg='#FAFAFA ' type='time' border='1px solid #ffe4d9' placeholder="Enter HappyHour From" name='happyHourFrom' value={formData.happyHourFrom} onChange={handleInputChange} />
                  
                  
              </Box>
               <Box width="20%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel>To</FormLabel>
                <Input w='80%'  bg='#FAFAFA ' type='time' border='1px solid #ffe4d9' placeholder="Enter HappyHour To" name='happyHourTo' value={formData.happyHourTo} onChange={handleInputChange} />
                  
                  
              </Box>
              
             
            </Box>
             <Box
              display="flex"
              gap="10px"
              alignItems="center"
              justifyContent="space-evenly"
              
            >
              <Box width="40%" display="flex" alignItems="center" boxShadow='xl'
              borderRadius="5px"
              p={4}>
                
                <Checkbox w='66%' bg='#FAFAFA '  border='1px solid #ffe4d9' placeholder="Enter Phone" name='priceAdd' isChecked={formData.priceAdd}  onChange={handleCheckboxChange}>Price Add</Checkbox>
                 
                 
                
              </Box>
              <Box width="40%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel>Add %</FormLabel>
                <Input w='70%'  bg='#FAFAFA ' border='1px solid #ffe4d9' placeholder="Enter %" name='priceAddPercentage' value={formData.priceAddPercentage} onChange={handleInputChange} />
                  
                  
              </Box>
              
              
             
            </Box>
            
            <Box
              display="flex"
              gap="10px"
              alignItems="center"
              justifyContent="space-evenly"
              
            >
                <Box width="40%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel>A/C No</FormLabel>
                <Input w='70%'  bg='#FAFAFA ' border='1px solid #ffe4d9' placeholder="Account Number" name='acNo' value={formData.acNo} onChange={handleInputChange} />
                  
                  
              </Box>
              <Box width="40%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel>IFSC</FormLabel>
                <Input w='80%'  bg='#FAFAFA ' border='1px solid #ffe4d9' placeholder="IFSC Code" name='ifsc' value={formData.ifsc} onChange={handleInputChange}/>
              </Box>
              
            </Box>
            <Box
              display="flex"
              gap="10px"
              alignItems="center"
              justifyContent="space-evenly"
              
            >
                <Box width="40%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel>Branch</FormLabel>
                <Input w='80%' bg='#FAFAFA ' border='1px solid #ffe4d9' placeholder="Branch Name" name='branch' value={formData.branch} onChange={handleInputChange} />
              </Box>
              
              <Box width="40%" display="flex" alignItems="center"  boxShadow='xl'
              borderRadius="5px"
              p={4}>
                <FormLabel>Image</FormLabel>
                <Input w='70%' type="file" bg='#FAFAFA ' border='1px solid #ffe4d9' onChange={handleFileChange}  />
                <Button variant='solid' onClick={handlePost} disabled={uploading}>
        {uploading ? "Uploading..." : "Upload"}
      </Button>
                
              </Box>
             
            </Box>
            
            
           
             
             
           
            
           
            
            
          <hr/>
          

          </Box>
         
          
          <Button type="submit" variant='solid' color='white' bg='tomato' _hover={{color:'tomato',bg:'white'}} mt={5} onClick={save}>{data && data.length>0?"Update":"Save"}</Button>
        </FormControl>
        
      </Box>
    );
  };
  
  export default PrintData;
  